// removed by extract-text-webpack-plugin
module.exports = {"discount-price":"app-components-receipt-refunds-RefundBreakdownModal-Discount-__Discount___F8k2Y"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/refunds/RefundBreakdownModal/Discount/Discount.css
// module id = 2242
// module chunks = 0